<ng-container *ngIf="displayedSubscriptions?.length; else noSubscriptions">
  <div class="subscriptions-container">
    <app-booking-subscription-details
      *ngFor="let subscription of displayedSubscriptions"
      [subscription]="subscription"
    ></app-booking-subscription-details>
  </div>
  <mat-paginator
    data-at-paginator
    paginator
    [length]="subscriptions.length"
    [pageIndex]="pagination.page"
    [pageSize]="pagination.pageSize"
    (page)="onPageChange($event)"
  ></mat-paginator>
</ng-container>
<ng-template #noSubscriptions>
  <div class="no-subscriptions">
    <app-no-search-results
      *ngIf="searchTerm; else noPackagesMessage"
      [searchTerm]="searchTerm"
    ></app-no-search-results>
    <ng-template #noPackagesMessage>
      <ng-container [ngSwitch]="activeSubscriptionsFilter">
        <ng-container *ngSwitchCase="filterType.ALL">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate: { packageType: '+BOOKING.OVERVIEW.FILTER.ALL' | translate }
          }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.PRO">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate: { packageType: '+BOOKING.OVERVIEW.FILTER.PRO' | translate }
          }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.PLUS">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate: { packageType: '+BOOKING.OVERVIEW.FILTER.PLUS' | translate }
          }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.AUTOMATIC_EXTENSION">
          {{ '+BOOKING.OVERVIEW.PACKAGES.NO_AUTOMATIC_EXTENSION_PACKAGES' | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="filterType.TRIAL">
          {{
            '+BOOKING.OVERVIEW.PACKAGES.NO_PACKAGES'
              | translate: { packageType: '+BOOKING.OVERVIEW.FILTER.TRIAL' | translate }
          }}
        </ng-container>
      </ng-container>
    </ng-template>
  </div>
</ng-template>
